// @flow
import React from 'react'
import type { Auction } from '../../services/auction/types'
import SmallText from '../texts/small-text'
import HeadingGamma from '../headings/heading-gamma'
import { Link } from 'react-router-dom'

type CardBodyItemProps = {
  item: {
    id: number,
    auction: Auction,
    title: string
  }
}

const CardBodyItem = (props: CardBodyItemProps) => {
  const { id, auction, title } = props.item
  return (
    <div className='card-body'>
      <Link to={`/items/${id}`}>
        <HeadingGamma>{title}</HeadingGamma>
      </Link>
      <SmallText light>{auction.title}</SmallText>
    </div>
  )
}

export default CardBodyItem



// WEBPACK FOOTER //
// ./src/ui/cards/card-body-item.js